import { render, staticRenderFns } from "./DailyNews.vue?vue&type=template&id=27009ed2&scoped=true"
import script from "./DailyNews.vue?vue&type=script&lang=js"
export * from "./DailyNews.vue?vue&type=script&lang=js"
import style0 from "./DailyNews.vue?vue&type=style&index=0&id=27009ed2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27009ed2",
  null
  
)

export default component.exports